import { CloudUploadOutlined } from '@mui/icons-material';
import { Button, styled } from '@mui/material';

import { useTheme } from '@/theme';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

interface UploadButtonProps {
  label: string;
  onUpload: React.MouseEventHandler<HTMLLabelElement> | undefined;
  onFileChange: React.ChangeEventHandler<HTMLInputElement, HTMLInputElement> | undefined;
  isLoading?: boolean;
}

const UploadButton = (props: UploadButtonProps) => {
  const theme = useTheme();
  return (
    <Button
      component='label'
      variant='contained'
      role={undefined}
      loading={props.isLoading}
      onClick={props.onUpload}
      tabIndex={-1}
      startIcon={<CloudUploadOutlined />}
      data-testid='upload-file-button'
      sx={{
        borderColor: theme.hhglobal.purpose.textStrong,
        color: theme.hhglobal.purpose.fillWeak,
        height: '36px',
        textTransform: 'none',
        alignSelf: 'flex-end',
        marginLeft: 'auto',
      }}
    >
      <VisuallyHiddenInput type='file' accept='.xlsx' onChange={props.onFileChange} data-testid='file-input' />

      {props.label}
    </Button>
  );
};

export default UploadButton;
